import { gameScenes } from '../games/rootScenes';
import { showMenu } from '../reactUi/showMenu';
import { resources } from '../Resources';
import { createEngine } from './createEngine';
import { inTransition } from './inTransition';
import { ShrapnelLoader } from './ShrapnelLoader';


export const startGame = async () => {
    const rootEngine = createEngine();
    rootEngine.start();
    const roots: Array<keyof typeof gameScenes> = [];
    for (const key in gameScenes) {
        roots.push(key as keyof typeof gameScenes);
    }
    const game = await showMenu({ options: roots.map(game => [`${game.slice(0, 1).toUpperCase() + game.slice(1)}`, game]), engine: rootEngine });
    rootEngine.stop();
    rootEngine.dispose();

    const sceneConfig = gameScenes[game];

    if ('path' in sceneConfig) {
        window.location.href = sceneConfig.path;
    } else {
        const engine = createEngine(sceneConfig.sceneMap);
        const loader = new ShrapnelLoader(resources.games.helicopters.scenes.splash);
        engine.start(sceneConfig.root, { loader, inTransition });
    }
};
